export enum ETipoDocumentoPromocion {
	BOLETA = 'BOLETA',
	FACTURA = 'FACTURA',
	NOTA_VENTA = 'NOTA_VENTA',
	TODOS = 'TODOS',
}
